import { useState, useEffect } from "react";
import PrimaryProductFieldTab from "../components/singleProduct/PrimaryProductFieldTab";
import SecondaryProductFieldTab from "../components/singleProduct/SecondaryProductFieldTab";
import OrderProductFieldTab from "../components/singleProduct/OrderProductFieldTab";
import FormulationProductTab from "../components/singleProduct/FormulationProductTab";
import { translateToReactSelect } from "../utils/helperFunction";
import { Helmet } from "react-helmet";
import "../components/singleProduct/SingleProduct.scss";
import { useParams } from "react-router";
import useAxios from "../services/useAxios";
import Tabs from "../components/tab/Tabs";

export default function SingleProduct() {
  const productConfig = [
    { value: 1, label: "فلت بگ" },
    { value: 2, label: "باکس بگ" },
    { value: 3, label: "پوشه" },
  ];
  const materialConfig = [{ value: 1, label: "پارچه" }];

  const { productId } = useParams();
  const answerType = [
    { label: "checkbox", value: "1" },
    { label: "radio", value: "2" },
    { label: "switch", value: "3" },
    { label: "input", value: "4" },
    { label: "select", value: "5" },
  ];
  // const productType = [
  //   { value: 2, label: "مواد اولیه" },
  //   { value: 1, label: "محصول نهایی" },
  //   { value: 3, label: "خدمت" },
  //   // { value: 4, label: "تسک" },
  // ];
  const [nav, setNav] = useState([]);
  const [tab, setTab] = useState([]);
  const [tabClickList, setTabClickList] = useState([]);
  // primary tabs info
  const [productMainType, setProductMainType] = useState(-1);

  // formulation
  const { loadingFindFormulation, execute: FindFormulation } = useAxios(
    "api/Find_Formulation"
  );
  const formulationsApi = async () => {
    let tempFormulationList = [];
    await FindFormulation({
      conditions: `product_service_id/=/${productId}`,
      tbl_name: `INNER JOIN,ProductServices,from_product_service_id,id`,
    }).then((Result) => {
      let sortResult = Result.sort((a, b) => a.sort - b.sort);
      setFormulationListData(
        translateToReactSelect(
          false,
          sortResult,
          "title",
          true,
          "from_product_service_id"
        )
      );
      tempFormulationList = translateToReactSelect(
        false,
        sortResult,
        "title",
        true,
        "from_product_service_id"
      );
    });

    if (productMainType == "1") {
      await FindProductService({ conditions: "main_type/in/2,4" }).then(
        (result) => {
          let temp = reduceTwoArray(
            translateToReactSelect(false, result, "title", true),
            tempFormulationList
          );
          setFormulationService(temp);
          setFormulationServiceOptionAll(
            translateToReactSelect(false, result, "title", true)
          );
        }
      );
    } else if (productMainType == 3) {
      await FindProductService({ conditions: "main_type/=/4" }).then(
        (result) => {
          let temp = [];
          temp = reduceTwoArray(
            translateToReactSelect(false, result, "title", true),
            tempFormulationList
          );
          setFormulationService(temp);
          setFormulationServiceOptionAll(result);
        }
      );
    }
  };
  const [formulationListData, setFormulationListData] = useState([
    // { label: "شیشه", count: "10", logistictm: "1000", value: "1" },
    // { label: "قالب", count: "10", logistictm: "1000", value: "2" },
  ]);
  const [formulationService, setFormulationService] = useState([
    // { value: "1", label: "َشیشه" },
    // { value: "2", label: "قالب" },
    // { value: "3", label: "توری" },
  ]);
  const [formulationServiceOptionAll, setFormulationServiceOptionAll] =
    useState([]);
  const formulationListDataHandler = (object) => {
    let temp = [...formulationListData, object];
    setFormulationListData(temp);
  };

  const reduceTwoArray = (bigArray, smallArray) => {
    let a = bigArray.filter((b) => !smallArray.find((s) => b.value == s.value));
    console.log("object temp red *****", bigArray, smallArray, a);
    return a;
  };
  const EditFormulation = (object, index) => {
    let temp = [...formulationListData];
    temp[index] = { ...temp[index], ...object };
    setFormulationListData(temp);
  };
  const deleteFormulationList = (index) => {
    let temp = [...formulationListData];
    temp.splice(index, 1);
    setFormulationService((prev) =>
      reduceTwoArray(formulationServiceOptionAll, temp)
    );
    console.log("object", formulationService, temp);
    setFormulationListData(temp);
  };
  const { loading, execute: FindProductService } = useAxios(
    "api/Find_ProductServices"
  );

  const tabList = [
    {
      main_type: "-1", //ساخت اولیه با params create
      nav: [{ title: "مشخصات اولیه", target: "#product-primary-fields" }],
      tabsComponent: [
        {
          id: "product-primary-fields",
          component: (
            <div className="">
              <PrimaryProductFieldTab
                // productType={productType}
                setProductMainType={setProductMainType}
                productMainType={productMainType}
                // data={primaryProductData}
                // dataHandler={primaryDataHandler}
                productId={productId}
                // productPrimaryUpdate={setPrimaryUpdate}
                productConfig={productConfig}
                materialConfig={materialConfig}
                // structureOption={structureOption}
              />
            </div>
          ),
        },
      ],
    },
    {
      main_type: "2", //مواد اولیه
      nav: [
        { title: "مشخصات اولیه", target: "#product-primary-fields" },
        // {
        //   title: (
        //     <div
        //       onClick={() => {
        //         if (!tabClickList.includes(1))
        //           setTabClickList((prev) => {
        //             return [...prev, 1];
        //           });
        //       }}
        //     >
        //       آپشن محصول
        //     </div>
        //   ),
        //   target: "#product-secondary-option-fields",
        // },
        {
          title: (
            <div
              onClick={() => {
                if (!tabClickList.includes(2))
                  setTabClickList((prev) => {
                    return [...prev, 2];
                  });
              }}
            >
              آپشن سفارش
            </div>
          ),
          target: "#product-order-option-fields",
        },
      ],
      tabsComponent: [
        {
          id: "product-primary-fields",
          component: (
            <div className="">
              <PrimaryProductFieldTab
                // productType={productType}
                setProductMainType={setProductMainType}
                productMainType={productMainType}
                // data={primaryProductData}
                // dataHandler={primaryDataHandler}
                productId={productId}
                // productPrimaryUpdate={setPrimaryUpdate}
                productConfig={productConfig}
                materialConfig={materialConfig}
                // structureOption={structureOption}
              />
            </div>
          ),
        },
        // {
        //   id: "product-secondary-option-fields",
        //   component: (
        //     <div className="">
        //       <SecondaryProductFieldTab
        //         tabClickList={tabClickList}
        //         answerType={answerType}
        //         productId={productId}
        //         // productOptionList={productOptionList}
        //         // productOptionsApi={productOptionsApi}
        //         // optionAnswerList={optionAnswerList}
        //         // setPOptionUpdater={setPOptionUpdater}
        //       />
        //     </div>
        //   ),
        // },
        {
          id: "product-order-option-fields",
          component: (
            <div className="">
              <OrderProductFieldTab
                answerType={answerType}
                productId={productId}
                tabClickList={tabClickList}
                // orderOptionList={orderOptionList}
                // optionAnswerList={optionOrderAnswerList}
                // orderOptionsApi={orderOptionsApi}
              />
            </div>
          ),
        },
      ],
    },
    {
      main_type: "3", //خدمت
      nav: [
        { title: "مشخصات اولیه", target: "#product-primary-fields" },
        // {
        //   title: <div onClick={() => formulationsApi()}>فرموله سازی</div>,
        //   target: "#formulation-fields",
        // },
      ],
      tabsComponent: [
        {
          id: "product-primary-fields",
          component: (
            <div className="">
              <PrimaryProductFieldTab
                // productType={productType}
                setProductMainType={setProductMainType}
                productMainType={productMainType}
                // data={primaryProductData}
                // dataHandler={primaryDataHandler}
                productId={productId}
                // productPrimaryUpdate={setPrimaryUpdate}
                productConfig={productConfig}
                materialConfig={materialConfig}
                // structureOption={structureOption}
              />
            </div>
          ),
        },
        // {
        //   id: "formulation-fields",
        //   component: (
        //     <div className="">
        //       <FormulationProductTab
        //         formulationService={formulationService}
        //         dataList={formulationListData}
        //         formulationListDataHandler={formulationListDataHandler}
        //         setFormulationService={setFormulationService}
        //         deleteFormulationList={deleteFormulationList}
        //         answerType={answerType}
        //         productId={productId}
        //         formulationsApi={formulationsApi}
        //         EditFormulation={EditFormulation}
        //       />
        //     </div>
        //   ),
        // },
      ],
    },
    {
      main_type: "1", //محصول نهایی
      nav: [
        { title: "مشخصات اولیه", target: "#product-primary-fields" },
        // {
        //   title: (
        //     <div
        //       onClick={() => {
        //         console.log(tabClickList.includes(1));
        //         if (!tabClickList.includes(1))
        //           setTabClickList((prev) => {
        //             return [...prev, 1];
        //           });
        //       }}
        //     >
        //       آپشن محصول
        //     </div>
        //   ),
        //   target: "#product-secondary-option-fields",
        // },
        {
          title: (
            <div
              onClick={() => {
                // orderOptionsApi();
                if (!tabClickList.includes(2))
                  setTabClickList((prev) => {
                    return [...prev, 2];
                  });
              }}
            >
              آپشن سفارش
            </div>
          ),
          target: "#product-order-option-fields",
        },
        // {
        //   title: <div onClick={() => formulationsApi()}>فرموله سازی</div>,
        //   target: "#formulation-fields",
        // },
      ],
      tabsComponent: [
        {
          id: "product-primary-fields",
          component: (
            <div className="">
              <PrimaryProductFieldTab
                // productType={productType}
                setProductMainType={setProductMainType}
                productMainType={productMainType}
                // data={primaryProductData}
                // dataHandler={primaryDataHandler}
                productId={productId}
                // productPrimaryUpdate={setPrimaryUpdate}
                productConfig={productConfig}
                materialConfig={materialConfig}
                // structureOption={structureOption}
              />
            </div>
          ),
        },
        // {
        //   id: "product-secondary-option-fields",
        //   component: (
        //     <div className="">
        //       <SecondaryProductFieldTab
        //         tabClickList={tabClickList}
        //         answerType={answerType}
        //         productId={productId}
        //         // productOptionList={productOptionList}
        //         // productOptionsApi={productOptionsApi}
        //         // optionAnswerList={optionAnswerList}
        //         // setPOptionUpdater={setPOptionUpdater}
        //       />
        //     </div>
        //   ),
        // },
        {
          id: "product-order-option-fields",
          component: (
            <div className="">
              <OrderProductFieldTab
                answerType={answerType}
                productId={productId}
                tabClickList={tabClickList}
                // orderOptionList={orderOptionList}
                // optionAnswerList={optionOrderAnswerList}
                // orderOptionsApi={orderOptionsApi}
              />
            </div>
          ),
        },
        // {
        //   id: "formulation-fields",
        //   component: (
        //     <div className="">
        //       <FormulationProductTab
        //         formulationService={formulationService}
        //         dataList={formulationListData}
        //         formulationListDataHandler={formulationListDataHandler}
        //         setFormulationService={setFormulationService}
        //         deleteFormulationList={deleteFormulationList}
        //         answerType={answerType}
        //         productId={productId}
        //         formulationsApi={formulationsApi}
        //         EditFormulation={EditFormulation}
        //       />
        //     </div>
        //   ),
        // },
      ],
      // tabsComponent: [
      //   <SecondaryProductFieldTab />,
      //   <OrderProductFieldTab />,
      //   <FormulationProductTab />,
      // ],
    },
    // {
    //   main_type: "4", //تسک
    //   nav: [
    //     { title: "مشخصات اولیه", target: "#product-primary-fields" },
    //     // { title: "فرموله سازی", target: "#formulation-fields" },
    //   ],
    //   tabsComponent: [
    //     {
    //       id: "product-primary-fields",
    //       component: (
    //         <div className="">
    //           <PrimaryProductFieldTab
    //             productType={productType}
    //             setProductMainType={setProductMainType}
    //             productMainType={productMainType}
    //             // data={primaryProductData}
    //             // dataHandler={primaryDataHandler}
    //             productId={productId}
    //             // productPrimaryUpdate={setPrimaryUpdate}
    //           />
    //         </div>
    //       ),
    //     },
    //     // {
    //     //   id: "formulation-fields",
    //     //   component: (
    //     //     <div className="">
    //     //       <FormulationProductTab
    //     //         formulationService={formulationService}
    //     //         dataList={formulationListData}
    //     //         formulationListDataHandler={formulationListDataHandler}
    //     //         setFormulationService={setFormulationService}
    //     //         deleteFormulationList={deleteFormulationList}
    //     //         answerType={answerType}
    //     //       />
    //     //     </div>
    //     //   ),
    //     // },
    //   ],
    // },
  ];

  useEffect(() => {
    let temp = [...tabList];
    console.log("test debug", temp);
    temp.filter((t) => {
      if (t.main_type == productMainType) {
        setNav((prev) => {
          return [...t.nav];
        });
        setTab((prev) => {
          return [...t.tabsComponent];
        });
      }
    });
  }, [
    productId,
    productMainType,
    tabClickList,
    formulationService,
    // optionOrderAnswerList,
    // orderOptionList,
    formulationListData,
  ]);

  return (
    <div className=" m-3 ">
      <Helmet>
        <title>محصول </title>
      </Helmet>
      <Tabs navItem={nav} tabContent={tab} type="horiz" />
    </div>
  );
}
